import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  create_hms_room_question_rating_action,
  get_hms_room_details_action,
  get_hms_room_questions_action,
  get_loggedin_user_meta_data_action,
  logout_user_action,
  update_hms_room_question_rating_action,
} from "../../../redux/_actions";

function useViewInterviewVideo() {
  const userInLocalStorage = JSON.parse(localStorage.getItem("jigsawUser"));
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [interviewQuestions, setInterviewQuestions] = useState([]);
  const [hmsRoomDetail, setHmsRoomDetail] = useState([]);
  const [question, setQuestion] = useState({});
  const [questionIndex, setQuestionIndex] = useState({});
  const [loading, setLoading] = useState(false);
  const [userMeta, setUserMeta] = useState({});
  const [questionRatingLoading, setQuestionRatingLoading] = useState(false);
  const [interviewPlayBackId, setInterviewPlayBackId] = useState(null);
  const [videoPlayBackDuration, setVideoPlayBackDuration] = useState(0);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );

  const { hmsRoomQuestionsData } = useSelector(
    (state) => state.get_hms_room_questions_reducer
  );

  const { hmsRoomDetailData } = useSelector(
    (state) => state.get_hms_room_details_reducer
  );

  useEffect(() => {
    window.scrollTo(0,0);
    getLoggedinUserApi();
  }, []);
  useEffect(() => {
    if (loggedInMetaData?.data) {
      setUserMeta(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);
  useEffect(() => {
    if (hmsRoomDetailData?.data) {
      let data = hmsRoomDetailData?.data;
      let hmsRoom0PlaybackId =
        data?.room_videos[0] && data.room_videos[0]?.video_playback_id;
      setInterviewPlayBackId(hmsRoom0PlaybackId);
      setHmsRoomDetail(hmsRoomDetailData?.data);
    }
  }, [hmsRoomDetailData]);

  useEffect(() => {
    if (hmsRoomQuestionsData?.data) {
      setInterviewQuestions(hmsRoomQuestionsData?.data);
    }
  }, [hmsRoomQuestionsData]);

  useEffect(() => {
    let hms_id = params?.hms_room_id;

    if (loggedInMetaData?.data) {
      callHmsRoomDetailsApi(hms_id);
      callQuestionsApi(hms_id);
    }
  }, [loggedInMetaData]);

  const callQuestionsApi = async (id) => {
    setLoading(true);
    await dispatch(get_hms_room_questions_action(id));
    setLoading(false);
  };

  const callHmsRoomDetailsApi = async (id) => {
    setLoading(true);
    await dispatch(get_hms_room_details_action(id));
    setLoading(false);
  };

  const getLoggedinUserApi = async () => {
    const stored_user =
      (await localStorage.getItem("jigsawUser")) &&
      JSON.parse(localStorage.getItem("jigsawUser"));

    if (stored_user) {
      setLoading(true);
      await dispatch(get_loggedin_user_meta_data_action());
    }
    setLoading(false);
  };

  const toggleSideBar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const onBackClick = () => {
    navigate(-1);
  };

  const onNextPrevClick = (id, type) => {
    let value = type === "add" ? 1 : type === "sub" ? -1 : 0;
    let index = interviewQuestions.findIndex((obj) => obj.id === id) + value;
    if (index > 0 || index < interviewQuestions.length) {
      let data = interviewQuestions[index];
      setQuestion(data);
      // if (data?.question) {
      //   getQuestionRatingApi(data.question);
      // }

      setQuestionIndex(index);
      navigateToVideoDuration(data);
    }
  };

  const onQuestionViewClick = async (id, val) => {
    let index = interviewQuestions.findIndex((obj) => obj.id === id);
    if (index >= 0 || index < interviewQuestions.length) {
      let data = interviewQuestions[index];
      setQuestion(data);
      setQuestionIndex(index);
      navigateToVideoDuration(data);
    }
  };

  const onLoginClick = async () => {
    if (userInLocalStorage && userInLocalStorage.refresh_token) {
      let data = { refresh: userInLocalStorage.refresh_token };
      await dispatch(logout_user_action(data));
    }
    navigate("/sign-in");
  };

  const onQuestionRatingChange = async (value) => {
    if (userMeta?.id === question?.created_by) {
      setQuestionRatingLoading(true);
      let data = {
        hms_question: question?.id,
        skill: question?.skills && question.skills[0],
        rating: value,
      };
      if (question?.rating === undefined || question?.rating === null)
        await dispatch(create_hms_room_question_rating_action(data));
      else
        await dispatch(
          update_hms_room_question_rating_action(question?.id, data)
        );

      let questionData = question;
      questionData["rating"] = value;
      setQuestion(questionData);
      setQuestionRatingLoading(false);
    }
  };

  const getJoineesNames = () => {
    let arr = [];
    if (hmsRoomDetail?.name) {
      if (arr[0]) arr[1] = hmsRoomDetail?.name;
      else arr[0] = hmsRoomDetail?.name;
    }
    if (hmsRoomDetail?.mentor) {
      if (arr[0]) arr[1] = hmsRoomDetail.mentor?.full_name;
      else arr[0] = hmsRoomDetail.mentor?.full_name;
    }
    if (hmsRoomDetail?.candidate) {
      if (arr[0]) arr[1] = hmsRoomDetail.candidate?.full_name;
      else arr[0] = hmsRoomDetail.mentor?.full_name;
    }
    if (hmsRoomDetail?.hiring_manager) {
      if (arr[0]) arr[1] = hmsRoomDetail.hiring_manager?.full_name;
      else arr[0] = hmsRoomDetail.mentor?.full_name;
    }
    return arr;
  };

  const navigateToVideoDuration = (data) => {
    let index =
      hmsRoomDetail?.room_videos &&
      hmsRoomDetail.room_videos.findIndex(
        (obj) => obj.session_id === data.session_id
      );
      if (index >= 0) {
        let sessionDetails = hmsRoomDetail.room_videos[index];
        setInterviewPlayBackId(sessionDetails?.video_playback_id)

        let sessionStartedTime = Math.floor(new Date(sessionDetails?.session_started_at) / 1000);
        let videoDuration = data?.unix_timestamp - sessionStartedTime

        setVideoPlayBackDuration(videoDuration);
      }
  };

  return {
    userMeta,
    interviewQuestions,
    interviewPlayBackId,
    hmsRoomDetail,
    videoPlayBackDuration,
    question,
    questionIndex,
    loading,
    sidebarCollapsed,
    toggleSideBar,
    onBackClick,
    onNextPrevClick,
    onQuestionViewClick,
    onLoginClick,
    onQuestionRatingChange,
    getJoineesNames,
  };
}

export default useViewInterviewVideo;

